
export const UpdateCta = () => {
  return (
    <div>UpdateManager</div>
  )
}
